module.exports = "<div id=about-view><second-menu :selectorid=\"'tab-selector-base'\" :tabs=tabs :synctab.sync=selectedTab :is-sticky=true></second-menu><div id=about-view-content><router-view></router-view></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/component/about/about-page.vue
// module id = 355
// module chunks = 0